import React, { useState } from 'react';

import { ReactComponent as ImageIcon } from '../../../icons/image.svg';
import { ReactComponent as LoaderIcon } from '../../../icons/loader.svg';

import { ImageCropModal } from './ImageCropModal';
import './image-upload.scss';

import { useImageUpload } from '../../../api/hooks/upload/useImageUpload';
import { getCroppedImageFile } from '../../../utils/image/cropImage';
import { Input } from '../input/Input';

export const ImageUpload = ({ compact, crop = false, cropAspect = 1, ...props }) => {
  const { upload, loading: imageUploading } = useImageUpload('/menus/upload');
  const [pendingFile, setPendingFile] = useState(null);
  const [pendingSrc, setPendingSrc] = useState(null);

  const uploadFile = (file) => {
    upload(file, {
      onSuccess: (result) => {
        try {
          props.onChange({ name: props.name, value: result.url });
        } catch (err) {
          //eslint-disable-next-line
          console.error('Image upload error:', err);
        }
      }
    });
  };

  const clearPending = () => {
    if (pendingSrc) URL.revokeObjectURL(pendingSrc);
    setPendingFile(null);
    setPendingSrc(null);
  };

  const handleFileSelected = (file) => {
    if (crop) {
      setPendingFile(file);
      setPendingSrc(URL.createObjectURL(file));
      return;
    }

    uploadFile(file);
  };

  const handleCropConfirm = async (croppedAreaPixels) => {
    try {
      const croppedFile = await getCroppedImageFile(
        pendingSrc,
        croppedAreaPixels,
        pendingFile.name
      );
      clearPending();
      uploadFile(croppedFile);
    } catch (err) {
      //eslint-disable-next-line
      console.error('Image crop error:', err);
      clearPending();
    }
  };

  return (
    <div className={`image-upload${compact ? ' image-upload--compact' : ''}`}>
      <div>
        <Input
          key={props.name}
          type="text"
          display
          {...props}
          placeholder={imageUploading ? 'Uploading...' : ''}
          onChange={() => {}}
        />
        {imageUploading ? <LoaderIcon /> : <ImageIcon />}
      </div>
      <Input
        key={`${props.name}-file`}
        type="file"
        label="file"
        props={{ accept: 'image/*' }}
        disabled={imageUploading}
        onChange={(e) => {
          const file = e.target.files?.[0];
          e.target.value = '';
          if (!file) return;

          if (!file.type.startsWith('image/')) {
            return;
          }

          handleFileSelected(file);
        }}
      />
      <div>
        {props.value ? (
          <img src={props.value} alt={`${props.name}-file`} />
        ) : (
          <span>Select an image</span>
        )}
      </div>
      {pendingSrc && (
        <ImageCropModal
          imageSrc={pendingSrc}
          aspect={cropAspect}
          onCancel={clearPending}
          onConfirm={handleCropConfirm}
        />
      )}
    </div>
  );
};
